"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lowestLevelBoldCommon = exports.lowestLevelSemiBold = exports.lowestLevelSemiBoldCommon = exports.lowestLevelBook = exports.lowestLevelBookCommon = exports.overline = exports.overlineCommon = exports.buttonEnterprise = exports.buttonLabel = exports.buttonCommon = exports.captionMedium = exports.captionMediumCommon = exports.captionLarge = exports.captionLargeCommon = exports.bodySmallSemiBold = exports.bodySmallSemiBoldCommon = exports.bodySmallBold = exports.bodySmallBoldCommon = exports.bodySmallBook = exports.bodySmallBookCommon = exports.bodyMediumSemiBold = exports.bodyMediumSemiBoldCommon = exports.bodyMediumBold = exports.bodyMediumBoldCommon = exports.bodyMediumBook = exports.bodyMediumBookCommon = exports.bodyLargeSemiBold = exports.bodyLargeSemiBoldCommon = exports.bodyLargeBold = exports.bodyLargeBoldCommon = exports.bodyLargeBook = exports.bodyLargeBookCommon = exports.bodyXLBook = exports.bodyXLBookCommon = exports.header4 = exports.header4Common = exports.header3 = exports.header3Common = exports.header2 = exports.header2Common = exports.header1 = exports.header1Common = exports.heroMedium = exports.heroMediumCommon = exports.heroLarge = exports.heroLargeCommon = exports.heroXL = exports.heroXLCommon = exports.disabledCoreVariants = exports.typographyVariantMapping = void 0;
exports.tabLabelActive = exports.tabLabelInactive = exports.tabLabelCommon = exports.textLinkLarge = exports.textLinkMedium = exports.textLinkSmall = exports.textLinkCommon = exports.floatingLabel = exports.chipLabel = exports.chipLabelCommon = exports.badgeLabel = exports.badgeLabelCommon = exports.accordionSmall = exports.accordionLarge = exports.mainNavigationLight = exports.mainNavigationDefaultSubCategory = exports.mainNavigationDefault = exports.breadcrumbSmall = exports.breadcrumbLarge = exports.breadcrumbCommon = exports.notification = exports.errorValidation = exports.errorValidationCommon = exports.assistiveText = exports.lowestLevelBold = void 0;
exports.typographyVariantMapping = {
    header1: 'h1',
    header2: 'h2',
    header3: 'h3',
    header4: 'h4',
    bodyXLBook: 'h4',
    heroLarge: 'h1',
    heroMedium: 'h3',
    heroXL: 'h1',
};
exports.disabledCoreVariants = {
    h1: undefined,
    h2: undefined,
    h3: undefined,
    h4: undefined,
    h5: undefined,
    h6: undefined,
    subtitle1: undefined,
    subtitle2: undefined,
    body1: undefined,
    body2: undefined,
};
exports.heroXLCommon = {
    fontFamily: 'Tiempos Headline',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '7rem',
    lineHeight: '7.25rem',
    letterSpacing: '-0.03125rem',
    '@media (max-width:600px)': {
        fontSize: '4rem',
        lineHeight: '4.5rem',
    },
};
exports.heroXL = {
    props: { variant: 'heroXL' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.heroXLCommon), { color: "var(--text-primary, ".concat(theme.palette.text.primary, ")") }));
    },
};
exports.heroLargeCommon = {
    fontFamily: 'Tiempos Headline',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '4rem',
    lineHeight: '5rem',
    letterSpacing: '-0.5px',
    '@media (max-width: 600px)': {
        fontSize: '2.5rem',
        lineHeight: '3.25rem',
    },
};
exports.heroLarge = {
    props: { variant: 'heroLarge' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.heroLargeCommon), { color: "var(--text-primary, ".concat(theme.palette.text.primary, ")") }));
    },
};
exports.heroMediumCommon = {
    fontFamily: 'Tiempos Headline',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '3.3rem',
    lineHeight: '4.25rem',
    letterSpacing: '-0.5px',
    '@media (max-width: 600px)': {
        fontSize: '2.5rem',
        lineHeight: '3.25rem',
    },
};
exports.heroMedium = {
    props: { variant: 'heroMedium' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.heroMediumCommon), { color: "var(--text-primary, ".concat(theme.palette.text.primary, ")") }));
    },
};
exports.header1Common = {
    fontFamily: 'Tiempos Headline',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '2.375rem',
    lineHeight: '3.25rem',
    letterSpacing: 0,
    '@media (max-width: 600px)': {
        fontSize: '1.8rem',
        lineHeight: '2.25rem',
    },
};
exports.header1 = {
    props: { variant: 'header1' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.header1Common), { color: "var(--text-primary, ".concat(theme.palette.text.primary, ")") }));
    },
};
exports.header2Common = {
    fontFamily: 'Tiempos Headline',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1.9375rem',
    lineHeight: '2.75rem',
    letterSpacing: 0,
    '@media (max-width: 600px)': {
        fontSize: '1.56rem',
        lineHeight: '2rem',
    },
};
exports.header2 = {
    props: { variant: 'header2' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.header2Common), { color: "var(--text-primary, ".concat(theme.palette.text.primary, ")") }));
    },
};
exports.header3Common = {
    fontFamily: 'Messina Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1.625rem',
    lineHeight: '2.25rem',
    letterSpacing: '-0.5px',
    '@media (max-width: 600px)': {
        fontSize: '1.375rem',
        lineHeight: '1.75rem',
    },
};
exports.header3 = {
    props: { variant: 'header3' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.header3Common), { color: "var(--text-primary, ".concat(theme.palette.text.primary, ")") }));
    },
};
exports.header4Common = {
    fontFamily: 'Messina Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1.375rem',
    lineHeight: '2rem',
    letterSpacing: '-0.5px',
    '@media (max-width: 600px)': {
        fontSize: '1.25rem',
        lineHeight: '1.75rem',
    },
};
exports.header4 = {
    props: { variant: 'header4' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.header4Common), { color: "var(--text-primary, ".concat(theme.palette.text.primary, ")") }));
    },
};
exports.bodyXLBookCommon = {
    fontFamily: 'Messina Sans',
    fontStyle: 'normal',
    fontWeight: 300,
    fontSize: '1.375rem',
    lineHeight: '2rem',
    letterSpacing: '-0.5px',
};
exports.bodyXLBook = {
    props: { variant: 'bodyXLBook' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.bodyXLBookCommon), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.bodyLargeBookCommon = {
    fontFamily: 'Messina Sans',
    fontStyle: 'normal',
    fontWeight: 300,
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
    letterSpacing: 0,
};
exports.bodyLargeBook = {
    props: { variant: 'bodyLargeBook' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.bodyLargeBookCommon), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.bodyLargeBoldCommon = {
    fontFamily: 'Messina Sans',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
    letterSpacing: 0,
};
exports.bodyLargeBold = {
    props: { variant: 'bodyLargeBold' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.bodyLargeBoldCommon), { color: "var(--text-primary, ".concat(theme.palette.text.primary, ")") }));
    },
};
exports.bodyLargeSemiBoldCommon = {
    fontFamily: 'Messina Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
    letterSpacing: 0,
};
exports.bodyLargeSemiBold = {
    props: { variant: 'bodyLargeSemiBold' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.bodyLargeSemiBoldCommon), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.bodyMediumBookCommon = {
    fontFamily: 'Messina Sans',
    fontStyle: 'normal',
    fontWeight: 350,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    letterSpacing: 0,
};
exports.bodyMediumBook = {
    props: { variant: 'bodyMediumBook' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.bodyMediumBookCommon), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.bodyMediumBoldCommon = {
    fontFamily: 'Messina Sans',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    letterSpacing: 0,
};
exports.bodyMediumBold = {
    props: { variant: 'bodyMediumBold' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.bodyMediumBoldCommon), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.bodyMediumSemiBoldCommon = {
    fontFamily: 'Messina Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    letterSpacing: 0,
};
exports.bodyMediumSemiBold = {
    props: { variant: 'bodyMediumSemiBold' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.bodyMediumSemiBoldCommon), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.bodySmallBookCommon = {
    fontFamily: 'Messina Sans',
    fontStyle: 'normal',
    fontWeight: 300,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    letterSpacing: 0,
};
exports.bodySmallBook = {
    props: { variant: 'bodySmallBook' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.bodySmallBookCommon), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.bodySmallBoldCommon = {
    fontFamily: 'Messina Sans',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    letterSpacing: 0,
};
exports.bodySmallBold = {
    props: { variant: 'bodySmallBold' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.bodySmallBoldCommon), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.bodySmallSemiBoldCommon = {
    fontFamily: 'Messina Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    letterSpacing: 0,
};
exports.bodySmallSemiBold = {
    props: { variant: 'bodySmallSemiBold' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.bodySmallSemiBoldCommon), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.captionLargeCommon = {
    fontFamily: 'Messina Sans',
    fontStyle: 'normal',
    fontWeight: 300,
    fontSize: '1rem',
    lineHeight: '1.25rem',
    letterSpacing: 0,
};
exports.captionLarge = {
    props: { variant: 'captionLarge' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.captionLargeCommon), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.captionMediumCommon = {
    fontFamily: 'Messina Sans',
    fontStyle: 'normal',
    fontWeight: 300,
    fontSize: '0.875rem',
    lineHeight: '1rem',
    letterSpacing: 0,
};
exports.captionMedium = {
    props: { variant: 'captionMedium' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.captionMediumCommon), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.buttonCommon = {
    fontFamily: 'Messina Sans',
    fontWeight: 700,
    fontSize: '1rem',
    lineHeight: '1.25rem',
    letterSpacing: '0px',
};
exports.buttonLabel = {
    props: { variant: 'buttonLabel' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.buttonCommon), { color: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")") }));
    },
};
exports.buttonEnterprise = {
    props: { variant: 'buttonEnterprise' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.buttonCommon), { color: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")") }));
    },
};
exports.overlineCommon = {
    fontFamily: 'Messina Sans Mono',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1rem',
    letterSpacing: '0.3px',
    textTransform: 'uppercase',
};
exports.overline = {
    props: { variant: 'overline' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.overlineCommon), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.lowestLevelBookCommon = {
    fontFamily: 'Messina Sans',
    fontStyle: 'normal',
    fontWeight: 300,
    fontSize: '0.75rem',
    lineHeight: '1rem',
    letterSpacing: '0.01875rem',
};
exports.lowestLevelBook = {
    props: { variant: 'lowestLevelBook' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.lowestLevelBookCommon), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.lowestLevelSemiBoldCommon = {
    fontFamily: 'Messina Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: '1rem',
    letterSpacing: '0.01875rem',
};
exports.lowestLevelSemiBold = {
    props: { variant: 'lowestLevelSemiBold' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.lowestLevelSemiBoldCommon), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.lowestLevelBoldCommon = {
    fontFamily: 'Messina Sans',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '0.75rem',
    lineHeight: '1rem',
    letterSpacing: '0.01875rem',
};
exports.lowestLevelBold = {
    props: { variant: 'lowestLevelBold' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.lowestLevelBoldCommon), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.assistiveText = {
    props: { variant: 'assistiveText' },
    style: function (_a) {
        var theme = _a.theme;
        return ({
            fontFamily: 'Messina Sans',
            fontWeight: 300,
            fontSize: '0.75rem',
            lineHeight: '1rem',
            color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"),
        });
    },
};
exports.errorValidationCommon = {
    fontFamily: 'Messina Sans',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '1rem',
};
exports.errorValidation = {
    props: { variant: 'errorValidation' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.errorValidationCommon), { color: theme.palette.error.dark }));
    },
};
exports.notification = {
    props: { variant: 'notification' },
    style: function (_a) {
        var theme = _a.theme;
        return ({
            fontFamily: 'Messina Sans',
            fontSize: '0.875rem',
            fontWeight: 300,
            lineHeight: '1.25rem',
            color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"),
        });
    },
};
exports.breadcrumbCommon = {
    fontFamily: 'Messina Sans',
    fontWeight: 300,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
};
exports.breadcrumbLarge = {
    props: { variant: 'breadcrumbLarge' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.breadcrumbCommon), { lineHeight: '1rem', fontSize: '0.875rem', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.breadcrumbSmall = {
    props: { variant: 'breadcrumbSmall' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.breadcrumbCommon), { lineHeight: '1rem', fontSize: '0.75rem', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.mainNavigationDefault = {
    props: { variant: 'mainNavigationDefault' },
    style: function (_a) {
        var theme = _a.theme;
        return ({
            fontFamily: 'Messina Sans',
            fontSize: '0.75rem',
            fontWeight: 700,
            lineHeight: '1.25rem',
            letterSpacing: '0.03125rem',
            textTransform: 'uppercase',
            color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"),
        });
    },
};
exports.mainNavigationDefaultSubCategory = {
    props: { variant: 'mainNavigationDefaultSubCategory' },
    style: function (_a) {
        var theme = _a.theme;
        return ({
            fontFamily: 'Messina Sans',
            fontSize: '0.75rem',
            fontWeight: 700,
            lineHeight: '1rem',
            letterSpacing: '0.0625rem',
            textTransform: 'uppercase',
            color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"),
        });
    },
};
exports.mainNavigationLight = {
    props: { variant: 'mainNavigationLight' },
    style: function (_a) {
        var theme = _a.theme;
        return ({
            fontFamily: 'Messina Sans',
            fontSize: '0.875rem',
            fontWeight: 350,
            lineHeight: '1.25rem',
            letterSpacing: 0,
            color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"),
        });
    },
};
exports.accordionLarge = {
    props: { variant: 'accordionLarge' },
    style: function (_a) {
        var theme = _a.theme;
        return ({
            fontFamily: 'Messina Sans',
            fontSize: '1.375rem',
            lineHeight: '2rem',
            letterSpacing: '-0.03125rem',
            color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"),
        });
    },
};
exports.accordionSmall = {
    props: { variant: 'accordionSmall' },
    style: function (_a) {
        var theme = _a.theme;
        return ({
            fontFamily: 'Messina Sans',
            fontSize: '1.125rem',
            lineHeight: '1.75rem',
            color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"),
        });
    },
};
exports.badgeLabelCommon = {
    fontFamily: 'Messina Sans',
    fontSize: '0.75rem',
    lineHeight: '1rem',
    letterSpacing: 0,
    fontWeight: 600,
};
exports.badgeLabel = {
    props: { variant: 'badgeLabel' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.badgeLabelCommon), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.chipLabelCommon = {
    fontFamily: 'Messina Sans',
    fontSize: '0.875rem',
    fontWeight: 600,
    lineHeight: '1.25rem',
    letterSpacing: 0,
};
exports.chipLabel = {
    props: { variant: 'chipLabel' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.chipLabelCommon), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
    },
};
exports.floatingLabel = {
    props: { variant: 'floatingLabel' },
    style: function (_a) {
        var theme = _a.theme;
        return ({
            fontFamily: 'Messina Sans',
            fontSize: '0.75rem',
            fontWeight: 300,
            lineHeight: '1rem',
            color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"),
        });
    },
};
exports.textLinkCommon = {
    fontFamily: 'Messina Sans',
    fontWeight: 300,
    textDecoration: 'underline',
};
exports.textLinkSmall = {
    props: { variant: 'textLinkSmall' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.textLinkCommon), { fontSize: '0.875rem', lineHeight: '1.25rem', color: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")") }));
    },
};
exports.textLinkMedium = {
    props: { variant: 'textLinkMedium' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.textLinkCommon), { fontSize: '1rem', lineHeight: '1.5rem', color: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")") }));
    },
};
exports.textLinkLarge = {
    props: { variant: 'textLinkLarge' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.textLinkCommon), { fontSize: '1.125rem', lineHeight: '1.75rem', color: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")") }));
    },
};
exports.tabLabelCommon = {
    fontFamily: 'Messina Sans',
    fontSize: '1rem',
    lineHeight: '1.25rem',
};
exports.tabLabelInactive = {
    props: { variant: 'tabLabelInactive' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.tabLabelCommon), { fontWeight: 300, color: "var(--text-primary, ".concat(theme.palette.text.primary, ")") }));
    },
};
exports.tabLabelActive = {
    props: { variant: 'tabLabelActive' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.tabLabelCommon), { fontWeight: 600, color: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")") }));
    },
};
